// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"f098951191a52a763387","297":"35676a79cffe84f8aa1e"}[chunkId] + ".js";
};